var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSundprojektLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140.563,
    height: 20.627,
    viewBox: "0 0 140.563 20.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3932",
    "data-name": "Rectangle 3932",
    width: 140.563,
    height: 20.627,
    fill: "#567c43"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6592",
    "data-name": "Group 6592",
    transform: "translate(-1 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6591",
    "data-name": "Group 6591",
    transform: "translate(1 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8993",
    "data-name": "Path 8993",
    d: "M51.138,18.093l1.3-1.553a4.575,4.575,0,0,0,2.978,1.209c.9,0,1.439-.356,1.439-.94v-.029c0-.555-.342-.841-2.009-1.268-2.009-.513-3.305-1.069-3.305-3.049v-.029c0-1.809,1.453-3.006,3.49-3.006a5.772,5.772,0,0,1,3.7,1.268l-1.14,1.653A4.681,4.681,0,0,0,55,11.367c-.841,0-1.282.385-1.282.869v.029c0,.655.427.869,2.151,1.311,2.023.527,3.163,1.253,3.163,2.992V16.6c0,1.979-1.51,3.092-3.662,3.092a6.345,6.345,0,0,1-4.231-1.594",
    transform: "translate(-23.024 -4.245)",
    fill: "#567c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8994",
    "data-name": "Path 8994",
    d: "M69.094,15.391v-5.7h2.194v5.642c0,1.625.812,2.465,2.151,2.465s2.152-.812,2.152-2.393V9.692h2.194v5.627c0,3.02-1.7,4.5-4.374,4.5s-4.317-1.495-4.317-4.431",
    transform: "translate(-31.108 -4.364)",
    fill: "#567c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8995",
    "data-name": "Path 8995",
    d: "M89.638,9.692h2.023l4.673,6.14V9.692H98.5v9.973H96.634L91.8,13.324v6.34H89.638Z",
    transform: "translate(-40.358 -4.363)",
    fill: "#567c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8996",
    "data-name": "Path 8996",
    d: "M110.7,9.692h3.888a4.972,4.972,0,0,1,5.3,4.958v.029a4.993,4.993,0,0,1-5.3,4.986h-3.889Zm3.889,7.993a2.841,2.841,0,0,0,3-2.669,2.884,2.884,0,0,0,0-.308v-.028a2.866,2.866,0,0,0-3.007-3h-1.7v6.012Z",
    transform: "translate(-49.838 -4.364)",
    fill: "#567c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8997",
    "data-name": "Path 8997",
    d: "M131.378,9.692h4.074c2.379,0,3.819,1.41,3.819,3.448v.029c0,2.309-1.8,3.5-4.032,3.5h-1.667v2.992h-2.194Zm3.932,5.029a1.542,1.542,0,0,0,1.738-1.51v-.029c0-.983-.684-1.51-1.781-1.51h-1.7v3.048Z",
    transform: "translate(-59.151 -4.364)",
    fill: "#567c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8998",
    "data-name": "Path 8998",
    d: "M149.087,9.686h4.559a3.977,3.977,0,0,1,2.907,1.012,3.133,3.133,0,0,1,.855,2.279v.029a3.1,3.1,0,0,1-2.137,3.092l2.437,3.562h-2.565l-2.137-3.189h-1.724v3.189h-2.195ZM153.5,14.53c1.069,0,1.681-.57,1.681-1.411v-.028c0-.94-.655-1.425-1.724-1.425h-2.179V14.53Z",
    transform: "translate(-67.124 -4.357)",
    fill: "#567c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8999",
    "data-name": "Path 8999",
    d: "M167.219,14.569v-.028a5.3,5.3,0,0,1,10.6-.029v.029a5.3,5.3,0,0,1-10.6.028Zm8.306,0v-.028a3.03,3.03,0,0,0-2.925-3.132l-.1,0a2.983,2.983,0,0,0-2.995,2.97c0,.045,0,.09,0,.135v.029a3.03,3.03,0,0,0,2.924,3.132l.1,0a2.983,2.983,0,0,0,2.995-2.97c0-.046,0-.091,0-.136",
    transform: "translate(-75.288 -4.226)",
    fill: "#567c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9000",
    "data-name": "Path 9000",
    d: "M186.864,18.312l1.382-1.539a2.46,2.46,0,0,0,1.824,1c.825,0,1.339-.5,1.339-1.653V9.692h2.254v6.525a3.62,3.62,0,0,1-.94,2.664,3.563,3.563,0,0,1-2.593.926,4.077,4.077,0,0,1-3.265-1.5",
    transform: "translate(-84.132 -4.364)",
    fill: "#567c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9001",
    "data-name": "Path 9001",
    d: "M203.979,9.692H211.5v1.952h-5.343v2.023h4.7v1.952h-4.7v2.095h5.415v1.952h-7.6Z",
    transform: "translate(-91.838 -4.363)",
    fill: "#567c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9002",
    "data-name": "Path 9002",
    d: "M222.043,9.692h2.194v4.36l4.046-4.36h2.65l-4.061,4.233,4.246,5.742h-2.636l-3.092-4.246-1.155,1.2v3.049h-2.194Z",
    transform: "translate(-99.971 -4.363)",
    fill: "#567c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9003",
    "data-name": "Path 9003",
    d: "M243.682,11.715h-3.035V9.692h8.264v2.023h-3.035v7.95h-2.195Z",
    transform: "translate(-108.348 -4.363)",
    fill: "#567c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9004",
    "data-name": "Path 9004",
    d: "M20.738,18a.11.11,0,0,1-.085-.175,6.542,6.542,0,0,0,1.35-4.2c0-4.295-3.947-4.986-7.764-5.655-3.224-.565-6.267-1.1-6.267-3.848A3.971,3.971,0,0,1,11.069.4l.1-.029c.075-.021.153-.042.231-.062a10.312,10.312,0,0,1,9.4,17.661.106.106,0,0,1-.071.027",
    transform: "translate(-3.589 0)",
    fill: "#567c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9005",
    "data-name": "Path 9005",
    d: "M10.312,23.43A10.31,10.31,0,0,1,2.619,6.254a.11.11,0,0,1,.176.122A5.294,5.294,0,0,0,2.21,8.862c0,4.254,3.752,5.011,7.381,5.742,3.167.639,6.442,1.3,6.442,4.438,0,2.157-1.434,3.732-3.838,4.214a10.452,10.452,0,0,1-1.883.174",
    transform: "translate(0 -2.803)",
    fill: "#567c43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSundprojektLogo);
export default __webpack_public_path__ + "static/media/sundprojektLogo.1f71f0340a1af5c810cd46e729e5eda4.svg";
export { ForwardRef as ReactComponent };